import { render, staticRenderFns } from "./page-evolution.vue?vue&type=template&id=17772768&"
import script from "./page-evolution.vue?vue&type=script&lang=js&"
export * from "./page-evolution.vue?vue&type=script&lang=js&"
import style0 from "./page-evolution.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports